export default ({ $gtm }) => {
	$gtm.init('GTM-N4PV39R')
}
